module.exports = __webpack_public_path__ + "static/media/sketch.73980499.svg";